export default __webpack_public_path__ + "static/media/help.fe72890d.svg";